import{withIcon as r}from"./withIcon.esm.js";import{jsx as t}from"react/jsx-runtime";var e=r((function(){return t("path",{fillRule:"evenodd",d:"m8 10 3.5-4h-7z"})}));export{e as default};
